import { ArrowUpRight } from "lucide-react";
import { WA_MESSAGES } from "../data/site";
import { waLink } from "../lib/whatsapp";
import { scrollToId } from "../lib/scroll";
import { WhatsAppButton } from "./Buttons";
import { Reveal } from "./Reveal";
import { SocialLinks } from "./SocialLinks";

export const FinalCTA = () => (
    <section className="girder-grid-light bg-brand-brown-deep py-20 sm:py-28" data-testid="final-cta-section">
        <div className="mx-auto max-w-5xl px-4 text-center sm:px-8">
            <Reveal>
                <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-brand-orange">
                    Ready when you are
                </p>
            </Reveal>
            <Reveal delay={0.08}>
                <h2 className="mt-5 font-display text-3xl font-bold leading-[1.08] tracking-tight text-brand-paper sm:text-4xl lg:text-5xl">
                    Your next customer is searching.
                    <span className="mt-1 block italic text-brand-orange">Will they find you — or a competitor?</span>
                </h2>
            </Reveal>
            <Reveal delay={0.16}>
                <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-brand-cream/75 sm:text-base">
                    Start with a business scan. We'll show you exactly where your customer journey leaks — and what to fix
                    first.
                </p>
            </Reveal>
            <Reveal delay={0.24}>
                <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
                    <button
                        type="button"
                        onClick={() => scrollToId("scan")}
                        data-testid="final-cta-scan-button"
                        className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-orange px-8 py-4 text-sm font-semibold text-white transition-colors duration-200 hover:bg-brand-orange-dark sm:text-base"
                    >
                        Business Scan
                        <ArrowUpRight size={18} aria-hidden="true" />
                    </button>
                    <WhatsAppButton href={waLink(WA_MESSAGES.grow)} testid="final-cta-whatsapp-button" dark />
                </div>
            </Reveal>
            <Reveal delay={0.32}>
                <div className="mt-12 flex flex-col items-center gap-4">
                    <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-cream/50">Follow &amp; message us</p>
                    <SocialLinks size="lg" testid="final-cta-social" />
                </div>
            </Reveal>
        </div>
    </section>
);
